import React from 'react'
import ProjectLayout from '../../components/projectLayout'
import data from '../../content/projects/udlWebsite'

export default function UdlWebsite() {
  return <ProjectLayout data={data} />
}
